<template>
  <div class="edit_goods_detail_point">
    <!-- @cancel="cancelRowEditDetailHandler" -->
    <!-- @accept="confirmEdit" -->
    <!-- accept-text="确定"
      cancel-text="取消" -->
    <!-- <vs-popup
      classContent="popup_goods_configs"
      fullscreen
      title="编辑商品"
      :active.sync="editPopUpActive"
    > -->
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '商品列表',
          url: '/goods/list',
        },
        {
          title: '编辑',
          active: true,
        },
      ]"
    ></vs-breadcrumb>
    <vx-card class="mb-6">
      <vs-tabs color="rgba(115,103,240,1)">
        <vs-tab label="商品信息">
          <template>
            <div class="vx-row mb-1">
              <!-- <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse"> -->
              <div class="vx-col w-1/5">
                <span class="inline-block">商品名称</span>
              </div>
              <div class="vx-col w-4/5">
                <vs-input v-model="name" />
              </div>
            </div>
            <div class="vx-row mb-1">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>商品广告语</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <vs-input class="w-full" v-model="slogan" />
              </div>
            </div>
            <div class="vx-row mb-1">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>商品分类</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <v-select
                  :options="categoryList"
                  label="name"
                  v-model="category"
                  :value="category ? category.name : ''"
                />
              </div>
            </div>
            <div class="vx-row mb-1">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>供货商</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <v-select
                  :options="merchantList"
                  label="name"
                  v-model="merchant"
                  :value="merchant ? merchant.name : ''"
                />
              </div>
            </div>
            <div class="vx-row mb-1">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>单价/市场价</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="price"
                      type="number"
                      placeholder="单价"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="market_price"
                      type="number"
                      placeholder="市场价"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-2 mt-2">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>是否团购</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <ul class="con-s">
                      <li>
                        <!-- <div class="mb-1">{{group_type === 2?'团购':'非团购'}}</div> -->
                        <vs-switch
                          v-model="groupTypeCheck"
                          @input="changeGroupType(groupTypeCheck)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-2" v-if="groupTypeCheck">
              <div class="vx-col sm:w-1/5 w-full flex flex-row-reverse">
                <span>团购价</span>
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="group_price"
                      type="number"
                      placeholder="团购价"
                    />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      class="w-full"
                      v-model="group_persons"
                      type="number"
                      placeholder="团购人数"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-1">
              <div
                class="
                  vx-col
                  sm:w-1/5
                  w-full
                  whitespace-no-wrap
                  flex flex-row-reverse
                "
                style="align-items: center"
              >
                <span class="whitespace-no-wrap" style="display: inline-block"
                  >单位/运费/采购价</span
                >
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="unit"
                      placeholder="单位"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="express"
                      placeholder="运费"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vs-input
                      class="w-full"
                      v-model="purchase_price"
                      type="number"
                      placeholder="采购价"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row mb-1">
              <div
                class="
                  vx-col
                  sm:w-1/5
                  whitespace-no-wrap
                  w-full
                  flex flex-row-reverse
                "
                style="align-items: center"
              >
                <span class="whitespace-no-wrap inline-block"
                  >满件数免运费</span
                >
              </div>
              <div class="vx-col sm:w-2/5 w-full">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input v-model="no_express_count" type="number" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="vx-row flex justify-end mr-2">
            <vs-button
              color="primary"
              type="filled"
              class="mr-1 block"
              @click="editGoods_detail_Confirm"
              >修改</vs-button
            >
            <vs-button class="block" type="border" @click="$router.go(-1)"
              >关闭</vs-button
            >
          </div>
        </vs-tab>
        <vs-tab label="海关申报" style="height: 60vh">
          <template>
            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">账册号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.emsNo"
                    class="w-full"
                    placeholder="emsNo"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">账册备案料号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.itemRecordNo"
                    class="w-full"
                    placeholder="itemRecordNo"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">企业商品名称&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.itemName"
                    class="w-full"
                    placeholder="itemName"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品编码&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gcode"
                    class="w-full"
                    placeholder="gcode"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品名称&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gname"
                    class="w-full"
                    placeholder="gname"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">商品规格型号&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.gmodel"
                    class="w-full"
                    placeholder="gmodel"
                  ></vs-input>
                </div>
              </div>
            </div>

            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">条码&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.barCode"
                    class="w-full"
                    placeholder="barCode"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">原产国&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.country"
                    class="w-full"
                    placeholder="country"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">贸易国&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.tradeCountry"
                    class="w-full"
                    placeholder="tradeCountry"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定数量&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.qty1"
                    class="w-full"
                    placeholder="qty1"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定第二数量</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.qty2"
                    class="w-full"
                    placeholder="qty2"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">申报单位&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit"
                    class="w-full"
                    placeholder="unit"
                  ></vs-input>
                </div>
              </div>
            </div>

            <div class="vx-row w-full mb-2">
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定计量单位&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit1"
                    class="w-full"
                    placeholder="unit1"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">法定第二计量单位</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.unit2"
                    class="w-full"
                    placeholder="unit2"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">毛重(kg)&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.grossWeight"
                    class="w-full"
                    placeholder="grossWeight"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">净重(kg)&nbsp;*</span>
                <div>
                  <vs-input
                    v-model="rowGoodPushObj.netWeight"
                    class="w-full"
                    placeholder="netWeight"
                  ></vs-input>
                </div>
              </div>
              <div class="vx-col sm:w-1/6 w-full flex flex-col">
                <span class="clear">代扣税率taxRate&nbsp;*</span>
                <div>
                  <v-select
                    :options="taxRateList"
                    label="name"
                    v-model="taxRateValue"
                    :value="taxRateValue ? taxRateValue.id : ''"
                  />
                </div>
              </div>
            </div>
          </template>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import merchantRepo from '@/repo/merchant'
export default {
  name: 'edit_goods_detail_point',
  props: ['itemRow', 'merchantList'],
  data() {
    return {
      index_id: '', //goods->id
      name: '',
      slogan: '', //商品广告语
      categoryList: [],
      category: {
        id: '',
        name: '',
        sort: '',
      },
      merchant: {
        id: '',
        name: '',
      },
      merchantList: [],
      price: '',
      market_price: '',
      groupTypeCheck: false,
      group_price: 0,
      group_persons: 0,
      purchase_price: '',
      group_type: '',
      unit: '',
      express: '',
      no_express_count: '',
    }
  },
  created() {
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id
      this.name = this.itemRow.name
      this.slogan = this.itemRow.slogan
      this.purchase_price = this.itemRow.purchase_price
      this.price = this.itemRow.price
      this.market_price = this.itemRow.market_price
      this.group_type = this.itemRow.group_type
      this.group_price = this.itemRow.group_price
      this.group_persons = this.itemRow.group_persons
      this.express = this.itemRow.express
      this.category = this.itemRow.category
      this.no_express_count = this.itemRow.no_express_count
      this.getMerchantList()
    }
  },
  methods: {
    changeGroupType: function () {
      this.groupTypeCheck = groupTypeCheck
    },
    editGoods_detail_Confirm: function () {
      //TODO
    },
    getMerchantList: function () {
      let that = this

      merchantRepo.getPullStoreList((error, data) => {
        const merchantList = data.data.map((v) => {
          return { id: v.id, name: v.store_name }
        })
        that.merchantList = merchantList
        that.merchant = that.merchantList.find(
          (v) => v.id == that.itemRow.store_id
        )
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit_goods_detail_point {
}
</style>
